// extracted by mini-css-extract-plugin
module.exports = {"main":"Avatar_main__1ShJu","image-container":"Avatar_image-container__2TiFZ"};